var currentToken  = localStorage.getItem("token");
var currentUser   = localStorage.getItem("user");
var currentSystem = localStorage.getItem("system");

currentUser = currentUser ? JSON.parse(currentUser) : false;
currentSystem = currentSystem ? JSON.parse(currentSystem) : false;

export default {
	debug: true,
	state: {
		currentRoute: window.location.pathname,
		currentUser: currentUser ? currentUser : false,
		currentSystem: currentSystem ? currentSystem : false,
		currentToken: currentToken ? currentToken : false,
	},
	setUserData(userData){
		localStorage.setItem('user', JSON.stringify(userData))
		this.state.currentUser = userData
	},
	setSystemData(data){
		localStorage.setItem('system', JSON.stringify(data))
		this.state.currentSystem = data
	},
	setUserToken(token){
		localStorage.setItem('token',token)
		this.state.currentToken = token
	},
	clearUser(){
		this.state.currentToken = false
		this.state.currentUser = false
		this.state.currentSystem = false
		localStorage.clear()
	},
	paramsUrlStr(params = {}){
		let str = "";
		for (let key in params) {
			if (str != "") {
				str += "&";
			}
			str += key + "=" + encodeURIComponent(params[key]);
		}
		return str != "" ? `?${str}` : ''
	}
}
